import axios from "axios";
import { store } from "@app-redux/store";
import { cleanupOnLogout } from "./auth";

let baseURL = process.env.REACT_APP_API_URL;
const httpApi = axios.create({
  baseURL,
  timeout: 1000 * 60 * 60, // 1 hour
});

httpApi.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      cleanupOnLogout();
    }
    return Promise.reject(error);
  }
);

export default httpApi;
